/**
 * DataConvert
 */
import React, { useEffect, useState } from 'react'
import { Button, Upload, message, Select } from 'antd'
import { ArrowRightOutlined, FolderOutlined } from '@ant-design/icons';
import './DataConvert.scss'
const Dragger = Upload.Dragger;
const { Option } = Select;
function DataConvert() {
    const myRef = React.useRef();
    const [acceptType, setAcceptType] = useState(".shp");
    const [toAcceptType, setToAcceptType] = useState("geojson");
    useEffect(() => {
        // 访问 DOM 元素
        myRef.current.focus();
        // console.log(acceptType+"更新");
    }, [acceptType]);
    // 每次重新渲染的时候能够缓存计算
    const props = {
        name: 'file',
        multiple: false,
        // accept:"image/*",
        accept: acceptType,
        maxCount: 1,
        action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
        onChange(info) {
            console.log(info);
            const { status } = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        beforeUpload(file) {
            const { name } = file;
            // 校验是否是excel文件
            const isExcel = /(xls|xlsx)$/i.test(name);
            if (!isExcel) {
                message.error();
            }
            // 自定义属性
            file.isExcel = isExcel;
            return isExcel;
        },
        onRemove(e) {
            console.log(e);
            // console.log('Dropped files', e.dataTransfer.files);
        },
        onDrop(e) {
            console.log(e);
            // console.log('Dropped files', e.dataTransfer.files);
        },
        customRequest(e) {
            console.log(e);
        }
    };
    const acceptChange = (e) => {
        setAcceptType(e);
    };
    const toAcceptChange = (e) => {
        setToAcceptType(e);
    };
    const onConvert = async (e) => {
        // try {
        //     const formData = new FormData();
        //     formData.append('file', fileList[0].originFileObj);
        //     const res = await submitBatchFile(formData);
        //     const { code } = res;
        //     if (code !== '000000') {
        //         throw new Error('提交失败');
        //     }
        //     message.success('提交成功');
        // } catch (e) {
        //     console.error(e);
        //     message.error(e.message);
        // }
    };
    return (
        <div className='data-convert' ref={myRef}>
            <div className='convert-upload'>
                <Dragger {...props}>
                    <p className="ant-upload-drag-icon">
                        {/* <Icon type="inbox" /> */}
                        <FolderOutlined />
                    </p>
                    <p className="ant-upload-text">上传文件</p>
                </Dragger>
            </div>
            <div className='convert-path'>
                <Select value={acceptType} style={{ width: 120 }} onChange={acceptChange}>
                    <Option value=".shp">.shp</Option>
                    <Option value=".gdb">GDB</Option>
                    <Option value=".KML">KML&KMZ</Option>
                    <Option value=".dwg">CAD</Option>
                </Select>
                <ArrowRightOutlined />
                <Select value={toAcceptType} style={{ width: 120 }} onChange={toAcceptChange}>
                    <Option value="geojson">GeoJson</Option>
                    <Option value="sql">SQL</Option>
                    <Option value=".xls">excel</Option>
                </Select>
            </div>
            <Button onClick={onConvert}>开始转换</Button>
        </div>
    )
}

//React.memo(),是一个高阶组件优,化函数式组件的渲染性能。它的主要作用是在组件接收的 props 没有发生变化时，阻止组件的不必要重新渲染。
export default React.memo(DataConvert);